import axios, { AxiosError } from 'axios';

import { MenuItem } from '@tassomutuo-backoffice/types';
import { axiosApiInstancePrivate } from '../index';
import configEnv from '../../../config/config';

interface ICreateMenuItem {
  name: string;
  page?: string;
  subItems: { name: string; page: string }[];
}

export const createFooterItem = async (data: ICreateMenuItem): Promise<void> => {
  try {
    const response = await axiosApiInstancePrivate.post(`/v1/footer`, data);

    return response.data?.results || [];
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const updateFooterItem = async ({
  footerItemId,
  data,
}: {
  footerItemId: string;
  data: ICreateMenuItem;
}): Promise<void> => {
  try {
    const response = await axiosApiInstancePrivate.patch(
      `/v1/footer/${footerItemId}`,
      data
    );

    return response.data?.results || [];
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const getFooterItemsInProd = async (): Promise<MenuItem[]> => {
  try {
    const response = await axios.get<MenuItem[]>(
      `${configEnv.apiUrlTassoProduction}/v1/footer`
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const getFooterItems = async (): Promise<MenuItem[]> => {
  try {
    const response = await axiosApiInstancePrivate.get<MenuItem[]>(`/v1/footer`);

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const deleteFooterItem = async (footerItemId: string): Promise<MenuItem> => {
  
  try {
    const response = await axiosApiInstancePrivate.delete<MenuItem>(
      `/v1/footer/${footerItemId}`
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const changeFooterItemsOrder = async (
  data: { id: string; order: number }[]
): Promise<MenuItem[]> => {
  try {
    const response = await axiosApiInstancePrivate.post<MenuItem[]>(
      `/v1/footer/change-order`,
      data
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const publishFooterItemsInProd = async (): Promise<void> => {
  try {
    const response = await axiosApiInstancePrivate.post<void>(
      `/v1/footer/publish-to-prod-client`
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};
